import * as Yup from "yup";
import { Dayjs } from "dayjs";

import { IClosedDays } from "@/interfaces/closed-days.interface";
import { ConfigurationTabMessages } from "@/messages/customer/configuration-tab.messages";

import { formatDateForApi, parseDateFromApi } from "../../constants";

export type ClosedDaysFormValues = {
  closedDay: Dayjs | null;
  description: string;
};

export const buildClosedDaysInitialData = (selected?: IClosedDays): ClosedDaysFormValues => {
  if (!selected) {
    return {
      closedDay: null,
      description: "",
    };
  }

  return {
    closedDay: parseDateFromApi(selected.closedDay),
    description: selected.description,
  };
};

export const buildClosedDaysFormSchema = (messages: ConfigurationTabMessages) =>
  Yup.object().shape({
    closedDay: Yup.mixed().nullable().required(messages.errorRequiredClosedDay),
    description: Yup.string().required(messages.errorRequiredClosedDayDescription).max(50),
  });

export const mapClosedDaysFormToInput = (values: ClosedDaysFormValues) => ({
  closedDay: formatDateForApi(values.closedDay),
  description: values.description.trim(),
});
